import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import AppContainer from '../AppContainer/AppContainer';
import AppImage from '../AppImage';
import AppTakeUp from '../AppTakeUp/AppTakeUp';
import AppLink from '../AppLink';
import { useHttp } from '../../hooks/network';
import { useTranslation } from '../../hooks/translation';

import AppServiceInnerTitle from './AppServiceInnerTitle';
import styles from './AppServiceInner.module.scss';

export default function AppServiceInner({ data }) {
  const { translate } = useTranslation();
  const { locale, query } = useRouter();
  const { request } = useHttp({ locale });
  const [services, setServices] = useState();

  const { title, desc, slider_image, bg_image, text, parent_slug } = data;

  const fetchServices = async () => {
    const response = await request({
      url: 'services',
      params: { item_id: data.row_item_id },
    });
    setServices(response.data);
  };

  useEffect(() => {
    fetchServices();
  }, [query]);

  return (
    <section className={styles.AppServiceInner}>
      <AppServiceInnerTitle title={title} desc={desc} />
      <div className={styles.AppServiceInner__SmallBanner}>
        <AppContainer>
          <div className={styles.AppServiceInner__SmallBanner__Image}>
            <AppImage src={bg_image?.url || slider_image.url} alt={title}></AppImage>
          </div>
        </AppContainer>
        <div className={'custom_Text_min'} dangerouslySetInnerHTML={{ __html: text }}></div>
      </div>
      <div className={styles.AppServiceInner__Services}>
        {services?.data.map((item, i) => (
          <div className={styles.AppOurService} key={i}>
            <div className={styles.AppOurService_Inner}>
              <figure>
                <AppImage src={item?.image.url} alt={item.title} />
              </figure>
              <h2>{item.title}</h2>
              <div className={styles.AppOurService_Link}>
                <AppLink
                  href={`${parent_slug}/${item.slug}`}
                  ariaLabel={translate('read_more')}
                  title={translate('read_more')}
                  className={styles.AppOurService_Arrow}>
                  <strong>{translate('read_more')}</strong>
                  <Arrow_Right />
                </AppLink>
              </div>
            </div>
          </div>
        ))}
      </div>
      <AppTakeUp />
    </section>
  );
}

function Arrow_Right() {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 8H15.5M15.5 8L8.5 1M15.5 8L8.5 15"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
